import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "wordWrap",
    standalone: false
})
export class WordWrapPipe implements PipeTransform {
  transform(value: string, wordsPerLine: number): string {
    var arr = value.split(" ");
    var newValue = "";

    for (var i = 0; i < arr.length; i++) {
      if ((i + 1) % wordsPerLine == 0) {
        newValue += arr[i].trim() + "\n";
      } else {
        newValue += arr[i].trim() + " ";
      }
    }

    return newValue;
  }
}
